<template>
	<az-container class="penalidades ma-0">
		<az-toolbar class="interna az-toolbar mt-6 mb-3">
			<template #actions v-if="totalItens">
				<botao-primario
					v-if="exibirBotaoAdicionar()"
					nome-botao="Adicionar"
					icone="mdi-plus-circle"
					@click="abrirModalPenalidade"
					v-az-auth="permissoes.pedidoUtilizacaoPenalidadesCriar"
				>
				</botao-primario>
			</template>
			<template #simpleSearch>
				<az-search
					:filter="filtro"
					simple-search-placeholder="Busque por: tipo ou fornecedor"
					@simple-search="buscar"
					ref="componenteAzSearch"
					@remove-filter="removerFiltros"
				>
				</az-search>
			</template>
		</az-toolbar>

		<listagem-itens
			:textos-do-template-da-listagem-vazia="textosDaListagemVazia"
			:colunas="getColunas()"
			:custom-columns="['valor']"
			:itens="datasource"
			:total-paginas="totalPaginas"
			:total-itens="totalItens"
			:paginacao="paginacao"
			@paginar="setPaginacao"
			@resetar-page="resetarPaginaListagem()"
			:tamanho-maximo-colunas="getTamanhoMaximoColunas()"
			show-actions
			listagem-vazia-custom
			listagem-vazia-custom-class="listagem-vazia"
		>
			<template #actions="{ item }">
				<listagem-penalidades-pedido-botoes-acoes
					@excluir="abrirOuFecharModalConfirmacaoExcluirPenalidade(item)"
					@editar="abrirModalPenalidade(item)"
					@visualizar="visualizarPenalidade(item)"
					@historico-notificacoes="abrirOuFecharModalHistoricoNotificacao(item)"
					:item="item"
					:autorizado-no-fluxo="autorizadoNoFluxo"
				></listagem-penalidades-pedido-botoes-acoes>
			</template>
			<template #acoes-listagem-vazia>
				<botao-primario
					v-if="exibirBotaoAdicionar()"
					nome-botao="Adicionar"
					icone="mdi-plus-circle"
					@click="abrirModalPenalidade"
					v-az-auth="permissoes.pedidoUtilizacaoPenalidadesCriar"
				>
				</botao-primario>
			</template>
		</listagem-itens>

		<modal-penalidade
			v-if="exibirModalPenalidade"
			:exibir="exibirModalPenalidade"
			:is-visualizar="isVisualizar"
			@fechar-modal="fecharModalPenalidade"
			:id-entidade="$route.params.id"
			:entidade-tipo="tipoPenalidade.PEDIDO_UTILIZACAO"
			:titulo-modal="getTituloModalPenalidade"
			:penalidade="penalidadeSelecionadaEditar"
			:id-ata="idAta"
			:id-pasta-externa-digital="idPastaExternaDigital"
			:notificacao-obrigatoria="penalidadePedidoObrigatoriaInfracao"
		>
			<template #listagem-documentos-entidade>
				<acessar-penalidades-pedido-documentos
					:id-pedido="idEntidade"
					:is-editar="isEditar"
					:penalidade-usa-fluxo="penalidadeUsaFluxo"
					:modo-visualizacao="isVisualizar"
				></acessar-penalidades-pedido-documentos>
			</template>
		</modal-penalidade>

		<modal-confirmacao
			:exibir="exibirModalConfirmacaoExcluirPenalidade"
			titulo-modal="Excluir"
			subtitulo-modal="Deseja realmente excluir?"
			mensagem="A infração/sanção excluída não poderá ser recuperada!"
			@fechar-modal="abrirOuFecharModalConfirmacaoExcluirPenalidade"
			@confirmar="excluirPenalidade"
		></modal-confirmacao>

		<modal-historico-notificacoes
			v-if="exibirModalHistoricoNotificacao"
			:exibir="exibirModalHistoricoNotificacao"
			:entidade-tipo="tipoPenalidade.PEDIDO_UTILIZACAO"
			titulo-modal="Histórico de Notificações"
			@fechar-modal="abrirOuFecharModalHistoricoNotificacao"
			:item="penalidadeSelecionadaHistorico"
		></modal-historico-notificacoes>
	</az-container>
</template>
<script>
import ModalPenalidade from '@/views/components/penalidade/ModalPenalidade'
import BotaoPrimario from '@/views/components/BotaoPrimario'
import { actionTypes, permissoes, tipoPenalidade } from '@/core/constants'
import ListagemItens from '@/views/components/ListagemItens'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'
import { TabelaColunaUtils } from '@/core/utils'
import ModalConfirmacao from '@/views/components/ModalConfirmacao'
import ListagemPenalidadesPedidoBotoesAcoes from '@/views/pages/pedido/acessar/penalidades/acoes/ListagemPenalidadesPedidoBotoesAcoes'
import { mapState } from 'vuex'
import arpBpmMixin from '@/views/mixins/bpm/arp-bpm-mixin'
import fluxoPedido from '@/views/mixins/bpm/fluxoPedido'
import validacaoPedido from '@/views/mixins/validacaoPedido'
import cabecalhoPedido from '@/views/mixins/cabecalhoPedido'
import deslogarOrgao from '@/views/mixins/deslogarOrgao'
import AcessarPenalidadesPedidoDocumentos from '@/views/pages/pedido/acessar/penalidades/documentos/AcessarPenalidadesPedidoDocumentos'
import ListagemPenalidadesBotoesAcoes from '@/views/pages/ata/acessar/penalidades/acoes/ListagemPenalidadesBotoesAcoes.vue'
import ModalHistoricoNotificacoes from '@/views/components/ModalHistoricoNotificacoes.vue'

export default {
	name: 'penalidades-pedido-view',
	components: {
		ModalHistoricoNotificacoes,
		ListagemPenalidadesBotoesAcoes,
		AcessarPenalidadesPedidoDocumentos,
		ListagemPenalidadesPedidoBotoesAcoes,
		ModalConfirmacao,
		ListagemItens,
		BotaoPrimario,
		ModalPenalidade,
	},
	mixins: [validacaoPedido, cabecalhoPedido, deslogarOrgao, arpBpmMixin, fluxoPedido],
	data() {
		return {
			idEntidade: this.$route.params.id,
			isEditar: this.$route.params.tipoAcesso === 'editar',
			paginacao: paginacaoListagem('id', 25, 'ASC'),
			datasource: [],
			totalPaginas: 0,
			totalItens: 0,
			filtro: {
				nomeFornecedorOuNomeOrgaoSancionadorOuTipoPenalidade: {
					default: null,
					label: 'Pesquisa',
					value: null,
				},
			},
			isComponenteAtivo: true,
			exibirModalPenalidade: false,
			penalidadeSelecionadaEditar: null,
			exibirModalConfirmacaoExcluirPenalidade: false,
			isVisualizar: false,
			penalidadeSelecionadaExcluir: null,
			usuarioPodeAdicionar: false,
			exibirModalHistoricoNotificacao: false,
			penalidadeSelecionadaHistorico: null,
		}
	},
	computed: {
		...mapState({
			idAta: (state) => state.pedido.informacoesPedido.ataRegistroPreco.id,
			numeroCasasDecimaisValores: (state) => state.pedido.informacoesPedido.numeroCasasDecimaisValores,
			idPastaExternaDigital: (state) => state.pedido.informacoesPedido.ataRegistroPreco.idPastaExternaDigital,
			penalidadeUsaFluxo: (state) => state.parametrosSistema.penalidadePedidoUsaFluxo,
			penalidadePedidoObrigatoriaInfracao: (state) => state.parametrosSistema.penalidadePedidoObrigatoriaInfracao,
		}),
		tipoPenalidade() {
			return tipoPenalidade
		},
		textosDaListagemVazia() {
			const textos = { titulo: 'Você não possui infrações e sanções cadastradas.' }

			if (this.verificarPermissao(permissoes.pedidoUtilizacaoPenalidadesCriar) && this.exibirBotaoAdicionar()) {
				textos['mensagem'] = 'Clique no botão para adicionar'
			}

			return textos
		},
		getTituloModalPenalidade() {
			if (this.penalidadeSelecionadaEditar) return 'Editar Infrações e Sanções'
			return 'Infrações e Sanções'
		},
	},
	async mounted() {
		await Promise.all([await this.buscarPermissoes(), await this.buscarPenalidades()])
	},
	beforeDestroy() {
		this.isComponenteAtivo = false
	},
	methods: {
		async buscarPenalidades() {
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.PENALIDADES.BUSCAR_PENALIDADES,
				this.montarPayloadBuscarPenalidades(),
			)

			this.datasource = itens
			this.totalItens = totalElements
			this.totalPaginas = totalPages
		},
		async buscarPermissoes() {
			const response = await this.$store.dispatch(actionTypes.PENALIDADES.VALIDAR_PENALIDADES, {
				idEntidade: this.idEntidade,
				tipo: tipoPenalidade.PEDIDO_UTILIZACAO,
			})

			this.usuarioPodeAdicionar = response.usuarioPodeAdicionar
		},
		montarPayloadBuscarPenalidades() {
			return {
				filtro: { ...this.filtro },
				idEntidade: { value: this.idEntidade },
				tipo: tipoPenalidade.PEDIDO_UTILIZACAO,
				paginacao: this.paginacao,
			}
		},
		exibirBotaoAdicionar() {
			return this.usuarioPodeAdicionar && this.autorizadoNoFluxo(this.permissoes.pedidoUtilizacaoPenalidadesCriar)
		},
		autorizadoNoFluxo(permissao) {
			if (!this.penalidadeUsaFluxo) return true

			return this.hasAuthority && this.isPermissaoAutorizada(permissao)
		},
		buscar(searchText) {
			if (searchText) {
				this.filtro.nomeFornecedorOuNomeOrgaoSancionadorOuTipoPenalidade.value = searchText.trim()
			}
			this.resetarPaginaListagem()
		},
		removerFiltros(propriedade) {
			if (this.filtro[propriedade]) {
				this.filtro[propriedade].value = this.filtro[propriedade].default
			}
			this.resetarPaginaListagem()
		},
		async resetarPaginaListagem() {
			this.paginacao.page = 1
			await this.buscarPenalidades()
		},
		async setPaginacao(paginacao) {
			this.paginacao = paginacao
			await this.buscarPenalidades()
		},
		getColunas() {
			const cols = [
				new TabelaColunaUtils('Fornecedor', 'nomeFornecedor', '35%'),
				new TabelaColunaUtils('Origem', 'origem', '25%'),
				new TabelaColunaUtils('Tipo', 'tipo', '15%'),
			]

			if (
				this.verificarPermissao(
					this.permissoes.pedidoUtilizacaoPenalidadesVisualizar,
					this.permissoes.pedidoUtilizacaoPenalidadesExcluir,
					this.permissoes.ataPenalidadesEditar,
				)
			) {
				cols.push(new TabelaColunaUtils('Ações', 'actions', '15%'))
			}

			return cols
		},
		getTamanhoMaximoColunas() {
			return {
				nomeFornecedor: 55,
				orgaoSancionador: 20,
				origem: 25,
				tipo: 30,
				valor: 15,
				situacao: 10,
			}
		},
		abrirModalPenalidade(penalidade) {
			this.isVisualizar = false
			this.penalidadeSelecionadaEditar = penalidade
			this.exibirModalPenalidade = true
		},
		visualizarPenalidade(penalidade) {
			this.isVisualizar = true
			this.penalidadeSelecionadaEditar = penalidade
			this.exibirModalPenalidade = true
		},
		async fecharModalPenalidade() {
			this.penalidadeSelecionadaEditar = null
			this.exibirModalPenalidade = false
			await this.buscarPenalidades()
		},
		abrirOuFecharModalConfirmacaoExcluirPenalidade(penalidade) {
			this.penalidadeSelecionadaExcluir = penalidade
			this.exibirModalConfirmacaoExcluirPenalidade = !this.exibirModalConfirmacaoExcluirPenalidade
		},
		async excluirPenalidade() {
			await this.$store
				.dispatch(actionTypes.PENALIDADES.EXCLUIR_PENALIDADE, {
					penalidade: this.penalidadeSelecionadaExcluir,
					tipo: tipoPenalidade.PEDIDO_UTILIZACAO,
				})
				.then(() => this.mostrarNotificacaoSucessoDefault())

			this.abrirOuFecharModalConfirmacaoExcluirPenalidade()
			await this.resetarPaginaListagem()
		},
		abrirOuFecharModalHistoricoNotificacao(penalidade) {
			this.penalidadeSelecionadaHistorico = penalidade
			this.exibirModalHistoricoNotificacao = !this.exibirModalHistoricoNotificacao
		},
	},
}
</script>
<style lang="stylus" scoped>
.penalidades

	.listagem-vazia
		padding 0.5rem 1.5rem
		margin 1.25rem

	.interna
		background-color white !important
		border none !important

	.icon-search
		margin-right 0 !important
</style>
